import React from "react";

export default function Loader() {
    return (
        <div
            className="d-flex flex-column"
            style={{
                position: "fixed",
                top: "0",
                width: "100%",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: ".5rem",
                zIndex: "9999",
            }}
        >
            <div className="loader--ring mt-5" />
            <div className="h2 fw-bold mt-5">Завантаження...</div>
        </div>
    );
}
